import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid white' }}
            date="Jul 2023 – Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">BDO India LLP</h3>
            <h4 className="vertical-timeline-element-subtitle">Bengaluru</h4>

            <div className="role-progression">
              <div className="role-row">
                <span className="role-title">Senior Executive</span>
                <span className="role-date">Apr 2025 – Present</span>
              </div>
              <div className="role-row">
                <span className="role-title">Executive</span>
                <span className="role-date">Dec 2023 – Apr 2025</span>
              </div>
              <div className="role-row">
                <span className="role-title">Intern</span>
                <span className="role-date">Jul 2023 – Dec 2023</span>
              </div>
            </div>

            <div className="tech-tags">
              <span>Angular 18 &amp; 21</span>
              <span>.NET 10</span>
              <span>Spring Boot</span>
              <span>SQL</span>
            </div>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;
